import React, { useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';
import {
  computeExpiryDateFromPackaging,
  computeLabelPrintCount,
  formatLabelDateFr,
  listAlignerLabelNumbers,
} from '../../../lib/productionLabelUtils';

export { computeLabelPrintCount } from '../../../lib/productionLabelUtils';

function LabelBarcode({ value }) {
  const svgRef = useRef(null);

  useEffect(() => {
    if (!svgRef.current || !value) return;
    try {
      JsBarcode(svgRef.current, String(value), {
        format: 'CODE128',
        width: 1.15,
        height: 26,
        displayValue: false,
        margin: 0,
        background: '#ffffff',
      });
    } catch (err) {
      console.warn('[LabelBarcode]', err);
    }
  }, [value]);

  return <svg ref={svgRef} className="max-w-full h-auto" aria-hidden />;
}

/**
 * Grille d'étiquettes aligneurs (hors fiche production / IPR).
 * Contenu : Aligneur num N · code-barres · n° commande · patient · expiration (+3 ans packaging).
 */
export default function ProductionSheetLabels({
  form,
  caseNumber,
  patientName,
  packagingDate,
  className = '',
}) {
  const numbers = listAlignerLabelNumbers(form);
  const orderNumber = caseNumber || '—';
  const name = patientName || '—';
  const expiry = formatLabelDateFr(computeExpiryDateFromPackaging(packagingDate));

  if (numbers.length === 0) {
    return (
      <div className={`production-labels-page p-6 text-center text-sm text-gray-500 ${className}`}>
        Aucune étiquette à imprimer — renseignez la plage Étiquette De / À sur la fiche.
      </div>
    );
  }

  return (
    <div className={`production-labels-page bg-white ${className}`}>
      <div className="production-labels-header px-4 pt-4 pb-3 border-b border-gray-200 print:hidden">
        <h2 className="text-base font-bold text-gray-900 uppercase tracking-wide">
          Étiquettes aligneurs
        </h2>
        <p className="text-xs text-gray-500 mt-0.5">
          {numbers.length} étiquette{numbers.length > 1 ? 's' : ''} · commande {orderNumber} · {name}
          {expiry ? ` · exp. ${expiry}` : ' · date d’emballage manquante'}
        </p>
      </div>

      <div className="production-labels-grid p-3 print:p-2">
        {numbers.map((n) => (
          <div key={n} className="production-label-card">
            <div className="text-[10px] font-bold text-gray-900 leading-tight text-center w-full">
              Aligneur num {n}
            </div>
            <div className="my-1 w-full flex justify-center">
              <LabelBarcode value={orderNumber === '—' ? 'CAS' : orderNumber} />
            </div>
            <div className="text-[9px] font-semibold text-gray-900 leading-tight truncate w-full text-center">
              {name}
            </div>
            <div className="text-[9px] text-gray-800 font-mono leading-tight truncate w-full text-center">
              N° commande : {orderNumber}
            </div>
            <div className="text-[9px] text-gray-600 leading-tight truncate w-full text-center mt-0.5">
              Exp. : {expiry || '—'}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
